export function formatWeight(ounces: number) {
  if (ounces === undefined || ounces === null) {
    return null
  }

  const lbs = Math.floor(ounces / 16)
  const oz = ounces % 16
  if (lbs === 0) {
    return `${oz} oz`
  }

  if (oz === 0) {
    return `${lbs} lbs`
  }

  return `${lbs} lb ${oz} oz`
}
